import React, { forwardRef, useEffect, useState } from "react";
import {
    Container,
  } from "react-bootstrap";
  import DatePicker from "react-datepicker";
import { SlCalender } from "react-icons/sl";
import { colors, initialAlert } from "../configs";
import '../App.css';
import { Button } from 'rsuite';
import { Modal_Alert, Modal_Loading } from "../modal";
import { useSelector } from "react-redux";
import { minusDays } from "../Utility/dateTime";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Outlet, NavLink } from 'react-router-dom';

const { white } = colors;

function TimeContainer({
    startDate,
    endDate,
    onChangeStart,
    onChangeEnd,
    show,
    search
}) {
    const navigate = useNavigate();
    const {  premiumEnable } = useSelector(state=>state.shop);
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div style={styles.container} onClick={onClick} ref={ref}>
          {value}
        </div>
    ));

    const [alert_Modal, setAlert_Modal] = useState(initialAlert);
    const { status, content, onClick, variant } = alert_Modal;

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {  // เอาไว้กำหนด display ของ sidebar
        // Function to update the window width state
       
    
        const handleResize = () => {
          setWindowWidth(window.innerWidth);
        };
    
        // Event listener to update the window width state on resize
        window.addEventListener('resize', handleResize);
    
        // Clean up the event listener when the component unmounts
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);



      function checkPremiumControl(date){
            const today = new Date();
            if(date<minusDays(today,62) && !premiumEnable){
                setAlert_Modal({
                    status:true,
                    content:`สมัครแพ็กเกจพรีเมี่ยม เพื่อใช้งานข้อมูลได้ไม่จำกัด\nแพ็กเกจที่คุณใช้งานอยู่ คือแพ็กเกจทดลอง สามารถดึงข้อมูลได้สูงสุด 60 วัน`,
                    onClick:()=>{navigate('/master/package')},
                    variant:'success'
                  })
                return;
            } 
            onChangeStart(date)

      };

  return (
    <Container
            fluid
            style={styles.container2}
            >
            <Modal_Alert
                show={status}
                onHide={()=>{setAlert_Modal(initialAlert)}}
                content={content}
                onClick={onClick}
                variant={variant}
            />
            <Modal_Loading show={show} />
            {windowWidth>500
                ?<div style={styles.container3} >
                    <SlCalender />
                    <div style={styles.container4} >  เริ่ม: </div>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={startDate}
                        onChange={checkPremiumControl}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        customInput={<ExampleCustomInput />}
                        withPortal
                    />
                </div>
                :<div style={styles.container5} >
                    <div style={styles.container4} >  เริ่ม: </div>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={startDate}
                        onChange={checkPremiumControl}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        customInput={<ExampleCustomInput />}
                        withPortal
                    />
                </div>
            }
            {windowWidth>500
                ?<div style={styles.container3} >
                    <SlCalender />
                    <div style={styles.container4} >  ถึง: </div>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={endDate}
                        onChange={onChangeEnd}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        customInput={<ExampleCustomInput />}
                        withPortal
                    />
                </div>
                :<div style={styles.container5} >
                    <div style={styles.container4} >  ถึง: </div>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={endDate}
                        onChange={onChangeEnd}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        customInput={<ExampleCustomInput />}
                        withPortal
                    />
                </div>
                
            }
            <Button onClick={search} color="orange" appearance="primary" >ค้นหา</Button>
        </Container>
  );
};

const styles = {
    container : {
        borderRadius:20
    },
    container2 : {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems:'center',
        marginTop:10,
        marginBottom:10
    },
    container3 : {
        display:'flex',padding:5,borderRadius:10,border: '1px solid grey',backgroundColor:white,alignItems:'center', margin:5
    },
    container4 : {
        paddingLeft:10,paddingRight:10
    },
    container5 : {
        display:'flex', flexDirection:'column',padding:5,borderRadius:10,border: '1px solid grey',backgroundColor:white,alignItems:'center', margin:5
    },
}

export default TimeContainer;
